import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 3v4a1 1 0 0 0 1 1h4","key":"svg-0"}],["path",{"d":"M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4","key":"svg-1"}],["path",{"d":"M4 15l4 6","key":"svg-2"}],["path",{"d":"M4 21l4 -6","key":"svg-3"}],["path",{"d":"M19 15v6h3","key":"svg-4"}],["path",{"d":"M11 21v-6l2.5 3l2.5 -3v6","key":"svg-5"}]]

const IconFileTypeXml = createReactComponent('outline', 'file-type-xml', 'FileTypeXml', __iconNode);

export default IconFileTypeXml;